define(['jquery', 'c21/charts/ChartGroup'], function ($, ChartGroup) {
   "use strict";

   var m_oData,
      m_jChartContainer,
      m_jSelect,
      m_chartGroup,
      m_labels;

   return {
      initialize : function(oData) {
         m_oData = oData;
         m_labels = {
            crime: {
               //m_smallChart.addLine(100); // National Average
               bars: [
                  { title: 'Total', key: 'crime_index' },
                  { title: 'Murder', key: 'murder_index' },
                  { title: 'Rape', key: 'forcible_rape_index' },
                  { title: 'Robbery', key: 'forcible_robbery_index' },
                  { title: 'Assault', key: 'aggravated_assault_index' },
                  { title: 'Burglary', key: 'burglary_index' },
                  { title: 'Larceny', key: 'larceny_index' },
                  { title: 'Vehicle key: Theft', key: 'motor_vehicle_index' }
               ]
            },
            expenses: {
               //m_smallChart.addLine(100); // National Average
               bars: [
                  { title: 'Total', key: 'annual_expenditures' },
                  { title: 'Insurance', key: 'personal_insurance_and_pensions' },
                  { title: 'Apparel', key: 'apparel_and_services' },
                  { title: 'Education', key: 'education' },
                  { title: 'Entertainment', key: 'entertainment' },
                  { title: 'Food', key: 'food' },
                  { title: 'Healthcare', key: 'healthcare' },
                  { title: 'Housing', key: 'housing' },
                  { title: 'Transportation', key: 'transportation' },
               ]
            },
            disasters: {
               //m_smallChart.addLine(100); // National Average
               bars: [
                  { title: 'Earthquake', key: 'earthquake_index' },
                  { title: 'Total key: Weather', key: 'weather_index' },
                  { title: 'Hail', key: 'hail_index' },
                  { title: 'Hurricane', key: 'hurricane_index' },
                  { title: 'Tornado', key: 'tornado_index' },
                  { title: 'Wind', key: 'wind_index' }
               ]
            },
            pollution: {
               //m_smallChart.addLine(100); // National Average
               bars: [
                  { title: 'Air', key: 'air_pollution_index' },
                  { title: 'Ozone', key: 'ozone_index' },
                  { title: 'Carbon key: Monoxide', key: 'carbon_monoxide_index' },
                  { title: 'Lead', key: 'lead_index' },
                  { title: 'NO<sub>2</sub>', key: 'nitrogen_dioxide_index' },
                  { title: 'Particulates(PM10)', key: 'particulate_matter_index' }
               ]
            }
         };
         
         m_jChartContainer = $('#localAreaIndexChart');
         if (m_jChartContainer.length === 0) return;
         m_jSelect = $('#localAreaIndexSelect');
         m_chartGroup = new ChartGroup(m_jChartContainer, m_jSelect, m_oData, m_labels);
         m_chartGroup.render();

         //m_jLocalAreaDataSubLabel = $('#localAreaIndexSubLabel');
         //m_smallChart.setMinMaxHeight(5, 120);
      }
   };
});
